<template>
    <div class="row"  >
        <!--column one-->
        <div class="col-md-4">
            <DeviceInfo/>
            <AttachedDevices/>
        </div>
        <!--column one-->   
        <!--column two-->
        <div class="col-md-4">
            <!--  SpeedTest 功能未开发 页面先不展示  -->
            <!-- <SpeedTest></SpeedTest> -->
            <InternetStatus/>
            <Wireless/>
            <Filink/>
        </div>
        <!--column two-->
        <!--column three-->
        <div class="col-md-4">
            <EasyDiagnostic/>
        </div>
        <!--column three-->
    </div>
</template>

<script>
import Layout from '@/components/layout'
import DeviceInfo from './deviceInfo'
import SpeedTest from './speedTest'
import EasyDiagnostic from './easyDiagnostic'
import AttachedDevices from './attachedDevices'
import InternetStatus from './internetStatus'
import Wireless from './wireless'
import Filink from './filink'
export default {
    name: 'home',
    components: {
        Layout,
        DeviceInfo,
        SpeedTest,
        EasyDiagnostic,
        AttachedDevices,
        InternetStatus,
        Wireless,
        Filink
    }
}
</script>

<style src="@/assets/style/home.scss" lang="scss"></style>
<style>
.home-btn > button{
    padding: 8px 20px;
    border-radius: 3px;
    font-size: 12px;
    background-color: #E8E8E8;
    border-color: #D0D0D0;
}
</style>
